'use client';

import type { ReactNode } from 'react';
import { EditToolArgsForm } from '../../HITL/forms/EditToolArgsForm';
import type { EditContentProps } from '../../tool-config-types';

export const renderDefaultEditContent = (
  props: EditContentProps,
): ReactNode => (
  <EditToolArgsForm
    onClose={props.onClose}
    onSubmit={props.onSubmit}
    toolName={props.toolName || 'unknown'}
    args={props.args || {}}
    hiddenFields={[]}
  />
);
